import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-slide-button',
  templateUrl: './slide-button.component.html',
  styleUrls: ['./slide-button.component.scss'],
})
export class SlideButtonComponent {
  @Output() onConfirmSwipe = new EventEmitter<boolean>();

  slideButtonItems = [
    {
      text: '>>',
      class: 'start',
    },
    {
      text: 'Slide to confirm',
      class: 'intermediate',
    },
    {
      text: ' ',
      class: 'end',
    },
  ];

  drop(event: CdkDragDrop<unknown>) {
    if (event.currentIndex === this.slideButtonItems.length - 1) {
      moveItemInArray(this.slideButtonItems, event.previousIndex, event.currentIndex);
      this.onConfirmSwipe.emit(true);
    }
  }
}
